<div
  *ngIf="showGstinSection"
  class="fixed inset-0 bg-black bg-opacity-50 z-[90]"
  (click)="onCancel()"
></div>
<section
  class="overflow-hidden bg-white fixed inset-0 h-full shadow-lg z-[100] w-full max-w-full max-md:bottom-0 max-md:top-auto max-md:h-auto max-md:max-h-[90vh] max-md:rounded-t-3xl max-md:flex max-md:flex-col sm:max-w-[484px] sm:fixed sm:right-0 sm:top-0 sm:inset-auto sm:h-full sm:rounded-none"
  [class.invisible]="!showGstinSection"
  [class.pointer-events-none]="!showGstinSection"
  [ngClass]="
    showGstinSection
      ? 'translate-x-0 max-md:translate-y-0'
      : 'translate-x-full max-md:translate-y-full'
  "
>
  <!-- Header -->
  <header
    class="flex-shrink-0 flex justify-between items-center px-4 py-4 w-full text-xl font-bold leading-none bg-white border-b border-solid border-b-[color:var(--Input-field-Stroke,#D4D4D4)] text-blue-950 max-md:px-6 max-md:py-6 max-md:text-2xl max-md:sticky max-md:top-0 max-md:z-10"
  >
    <!-- Mobile drag handle indicator -->
    <div
      class="max-md:flex max-md:justify-center max-md:w-full max-md:absolute max-md:top-2 max-md:left-1/2 max-md:transform max-md:-translate-x-1/2 hidden"
    >
      <div class="w-12 h-1 bg-gray-300 rounded-full"></div>
    </div>

    <h1 class="truncate max-md:text-xl max-md:mt-4">Select GSTIN</h1>
    <button
      class="w-6 h-6 flex items-center justify-center cursor-pointer max-md:w-8 max-md:h-8 max-md:text-3xl"
      (click)="onCancel()"
    >
      <span class="text-2xl font-light max-md:text-3xl">×</span>
    </button>
  </header>

  <!-- Main - Scrollable Content -->
  <main
    class="flex-1 overflow-y-auto px-4 py-6 w-full bg-white max-md:h-auto max-md:max-h-[calc(90vh-120px)] max-md:pb-20 max-md:px-6"
  >
    <div class="w-full space-y-6 max-md:px-0">
      <form [formGroup]="gstForm" class="w-full space-y-6">
        <!-- GSTIN Input -->
        <div class="w-full">
          <label class="block text-sm font-bold text-zinc-700 mb-2"
            >GSTIN</label
          >
          <div class="relative" #gstinDropdown>
            <button
              type="button"
              class="w-full px-3 py-3 text-base font-medium rounded-lg border focus:border-blue-500 focus:outline-none bg-white text-left flex items-center justify-between gap-2"
              [class.border-blue-500]="gstinDropdownOpen"
              [class.border-zinc-300]="!gstinDropdownOpen"
              [class.text-neutral-400]="!gstForm.get('gst_number')?.value"
              [class.text-neutral-700]="!!gstForm.get('gst_number')?.value"
              [disabled]="gstinsLoading || gstins.length === 0"
              (click)="toggleGstinDropdown()"
            >
              <span class="truncate uppercase">{{ gstinTriggerLabel }}</span>
              <svg
                class="w-4 h-4 flex-shrink-0 text-neutral-500 transition-transform"
                [class.rotate-180]="gstinDropdownOpen"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>

            <div
              *ngIf="gstinDropdownOpen"
              class="absolute z-20 mt-1 w-full max-h-60 overflow-y-auto rounded-lg border border-zinc-300 bg-white shadow-lg"
            >
              <button
                type="button"
                *ngFor="let g of gstins"
                class="w-full relative flex justify-between items-center px-3 py-3 text-left border-b border-zinc-100 last:border-b-0"
                [class.bg-blue-50]="isGstinSelected(g)"
                [class.text-neutral-700]="isGstinActive(g)"
                [class.opacity-40]="!isGstinActive(g)"
                [class.bg-gray-100]="!isGstinActive(g)"
                [class.cursor-pointer]="isGstinActive(g)"
                [class.hover:bg-blue-50]="isGstinActive(g)"
                [class.cursor-not-allowed]="!isGstinActive(g)"
                [disabled]="!isGstinActive(g)"
                (click)="selectGstinFromList(g)"
              >
                <div class="flex flex-col pr-16 min-w-0">
                  <span
                    class="font-medium text-sm uppercase break-all"
                    [class.line-through]="!isGstinActive(g)"
                    [class.text-neutral-400]="!isGstinActive(g)"
                  >
                    {{ getGstinNumber(g) }}
                  </span>
                  <span
                    *ngIf="g.state"
                    class="text-xs text-neutral-500"
                    >{{ g.state }}</span
                  >
                </div>
                <span
                  *ngIf="!isGstinActive(g)"
                  class="absolute top-2 right-2 text-[10px] font-semibold text-red-500 uppercase tracking-wide"
                >
                  {{ getGstinStatus(g) }}
                </span>
              </button>
            </div>
          </div>
          <p *ngIf="gstinsError" class="text-red-500 text-xs mt-1">
            {{ gstinsError }}
          </p>
          <p
            *ngIf="!gstinsLoading && !gstinsError && gstins.length === 0"
            class="text-neutral-500 text-xs mt-1"
          >
            No GSTINs found. Complete business verification first.
          </p>
          <div>
            <div
              *ngIf="
                gstForm.get('gst_number')?.invalid &&
                gstForm.get('gst_number')?.touched
              "
            >
              <span
                *ngIf="gstForm.get('gst_number')?.hasError('required')"
                class="text-red-500 text-xs mt-1 block"
                >GST number is required</span
              >
              <span
                *ngIf="
                  gstForm.get('gst_number')?.hasError('minlength') ||
                  gstForm.get('gst_number')?.hasError('maxlength')
                "
                class="text-red-500 text-xs mt-1 block"
                >GST number must be exactly 15 characters</span
              >
              <span
                *ngIf="gstForm.get('gst_number')?.hasError('invalidGst')"
                class="text-red-500 text-xs mt-1 block"
                >Invalid GST format. Format: 22AAAAA0000A1Z5</span
              >
            </div>
          </div>
        </div>

        <!-- Company Info Section -->
        <section class="w-full">
          <div class="mb-4">
            <h2 class="text-lg font-bold text-black">Company Name & Address</h2>
            <p class="mt-1 text-sm font-medium text-black">
              Order will be billed to the registered Company Name and GST
              address.
            </p>
          </div>

          <div class="space-y-4">
            <!-- Company Name -->
            <div class="w-full">
              <label class="block text-sm font-bold text-zinc-700 mb-2">
                Company Name
              </label>
              <input
                type="text"
                placeholder="Registered company name"
                class="w-full px-3 py-3 text-base font-medium rounded-lg text-neutral-400 border border-zinc-300 bg-gray-100 cursor-not-allowed"
                formControlName="company_name"
                [disabled]="true"
              />
            </div>

            <!-- Address Line -->
            <div class="w-full">
              <label class="block text-sm font-bold text-zinc-700 mb-2">
                Flat, House no., Building, Company, Apartment
              </label>
              <input
                type="text"
                placeholder="Enter Flat, Building, Company, Apartment"
                class="w-full px-3 py-3 text-base font-medium rounded-lg text-neutral-400 border border-zinc-300 bg-gray-100 cursor-not-allowed"
                formControlName="address_1"
                [disabled]="true"
              />
            </div>

            <!-- Two column layout for both mobile and desktop -->
            <div class="grid grid-cols-2 gap-4 max-md:gap-3">
              <!-- Locality -->
              <div class="w-full">
                <label class="block text-sm font-bold text-zinc-700 mb-2">
                  Locality
                </label>
                <input
                  type="text"
                  placeholder="Nearby location"
                  class="w-full px-3 py-3 text-base font-medium rounded-lg text-neutral-400 border border-zinc-300 bg-gray-100 cursor-not-allowed"
                  formControlName="locality"
                  [disabled]="true"
                />
              </div>

              <!-- PIN Code -->
              <div class="w-full">
                <label class="block text-sm font-bold text-zinc-700 mb-2">
                  PIN
                </label>
                <input
                  type="text"
                  placeholder="Pincode"
                  class="w-full px-3 py-3 text-base font-medium rounded-lg text-neutral-400 border border-zinc-300 bg-gray-100 cursor-not-allowed"
                  formControlName="pincode"
                  [disabled]="true"
                />
              </div>
            </div>

            <!-- Two column layout for both mobile and desktop -->
            <div class="grid grid-cols-2 gap-4 max-md:gap-3">
              <!-- City/Town -->
              <div class="w-full">
                <label class="block text-sm font-bold text-zinc-700 mb-2">
                  City/Town
                </label>
                <input
                  type="text"
                  placeholder="City name"
                  class="w-full px-3 py-3 text-base font-medium rounded-lg text-neutral-400 border border-zinc-300 bg-gray-100 cursor-not-allowed"
                  formControlName="city"
                  [disabled]="true"
                />
              </div>

              <!-- State -->
              <div class="w-full">
                <label class="block text-sm font-bold text-zinc-700 mb-2">
                  State
                </label>
                <input
                  type="text"
                  placeholder="State name"
                  class="w-full px-3 py-3 text-base font-medium rounded-lg text-neutral-400 border border-zinc-300 bg-gray-100 cursor-not-allowed"
                  formControlName="state"
                  [disabled]="true"
                />
              </div>
            </div>
          </div>
        </section>
      </form>
    </div>
  </main>

  <!-- Footer - Sticky at bottom -->
  <footer
    class="flex-shrink-0 flex flex-row gap-3 sm:gap-6 items-center px-4 sm:px-8 py-4 sm:py-6 w-full text-base font-bold text-center bg-white border-t border-solid border-t-[color:var(--Neutrals-Light-Gray,#C0C5C7)]"
  >
    <button
      (click)="onCancel()"
      class="w-full sm:flex-1 flex justify-center items-center p-3 whitespace-nowrap rounded-lg text-blue-950 border border-blue-950 hover:bg-blue-50 transition-colors max-md:p-4 max-md:text-lg max-md:rounded-xl"
    >
      Cancel
    </button>
    <button
      class="w-full sm:flex-1 flex justify-center items-center p-3 text-white rounded-lg transition-colors max-md:p-4 max-md:text-lg max-md:rounded-xl"
      [class.bg-blue-950]="gstForm.valid && !gstForm.pristine"
      [class.hover:bg-blue-800]="gstForm.valid && !gstForm.pristine"
      [class.bg-gray-400]="!gstForm.valid || gstForm.pristine"
      [class.cursor-not-allowed]="!gstForm.valid || gstForm.pristine"
      [disabled]="!gstForm.valid || gstForm.pristine"
      (click)="addGstdata()"
    >
      Save
    </button>
  </footer>
</section>
